import { ProductData } from 'lib/types'
import { GTM, ListPages } from 'lib/core/services/gtm'
import { Product } from 'lib/core/services/gtm/types'
import { Ga4Events } from '../../../../gtm/index'

export const triggerItemList = (products: ProductData[], category: string) => {
  const categoryProducts: Product[] = []

  products.forEach(product => {
    const { sku } = product

    categoryProducts.push({
      id: sku,
      name: product?.name ?? '',
      category: category,
      list: 'Category Page' as ListPages
    })
  })

  if (categoryProducts.length) {
    GTM.productImpressions({
      products: categoryProducts
    })
    Ga4Events.viewItems({
      itemListName: 'Category Page',
      products: products ?? []
    })
  }
}

export const triggerSearch = (products: ProductData[], searchTerm: string) => {
  const searchProducts: Product[] = []

  products.forEach(product => {
    const { sku } = product

    searchProducts.push({
      id: sku,
      name: product?.name ?? '',
      list: 'Search Page' as ListPages
    })
  })

  if (searchProducts.length) {
    GTM.productImpressions({
      products: searchProducts
    })
    Ga4Events.viewItems({
      itemListName: 'Search Page',
      products: products ?? []
    })
    Ga4Events.search({ searchTerm: searchTerm ?? '' })
  }
}
